module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Illustration#fm-1"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Reader#fm-2"
    }
  }, [_vm._v("To the Reader")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Ack#fm-3"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Abbrevation#fm-4"
    }
  }, [_vm._v("List of Abbreviations and Sigla")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#pt-1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-1"
    }
  }, [_vm._v("1.0 Texts and Versions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-1"
    }
  }, [_vm._v("1.1 Hebrew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-1"
    }
  }, [_vm._v("1.1.1 Masoretic Text")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-2"
    }
  }, [_vm._v("1.1.2 Qumran Hebrew Texts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-2"
    }
  }, [_vm._v("1.2 Greek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-3"
    }
  }, [_vm._v("1.2.1 Greek Minor Prophets Scroll from Na"), _c('span', {
    staticClass: "font1"
  }, [_vm._v("ḥ")]), _vm._v("al "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("Ḥ")]), _vm._v("ever")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-4"
    }
  }, [_vm._v("1.2.2 The Greek Book of Jonah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-5"
    }
  }, [_vm._v("1.2.3 Old Latin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-3"
    }
  }, [_vm._v("1.3 Vulgate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-4"
    }
  }, [_vm._v("1.4 Aramaic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-5"
    }
  }, [_vm._v("1.5 Syriac")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-2"
    }
  }, [_vm._v("2.0 Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-6"
    }
  }, [_vm._v("2.1 Vocabulary and Forms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-7"
    }
  }, [_vm._v("2.2 Late Biblical Hebrew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-6"
    }
  }, [_vm._v("2.2.1 Semantic Change Indicative of Lateness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-7"
    }
  }, [_vm._v("2.2.2 Syntactic Features Indicative of Lateness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-8"
    }
  }, [_vm._v("2.3 Foreignizing or Archaizing Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-3"
    }
  }, [_vm._v("3.0 Integrity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-4"
    }
  }, [_vm._v("4.0 Provenance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-9"
    }
  }, [_vm._v("4.1 The Scribalization of Prophecy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-10"
    }
  }, [_vm._v("4.2 The Written Word in Postexilic Yehud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-5"
    }
  }, [_vm._v("5.0 Setting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-6"
    }
  }, [_vm._v("6.0 Genre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-11"
    }
  }, [_vm._v("6.1 Didactic Story about a Prophet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-12"
    }
  }, [_vm._v("6.2 Satire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-13"
    }
  }, [_vm._v("6.3 Epic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-7"
    }
  }, [_vm._v("7.0 Artistry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-14"
    }
  }, [_vm._v("7.1 Humor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-15"
    }
  }, [_vm._v("7.2 Allusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-8"
    }
  }, [_vm._v("8.0 Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-16"
    }
  }, [_vm._v("8.1 Jonah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-17"
    }
  }, [_vm._v("8.2 YHWH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-18"
    }
  }, [_vm._v("8.3 The Sailors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-19"
    }
  }, [_vm._v("8.4 The Ninevites (Nineveh)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-20"
    }
  }, [_vm._v("8.5 The King of Nineveh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-9"
    }
  }, [_vm._v("9.0 History of Consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-21"
    }
  }, [_vm._v("9.1 Jewish Consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-8"
    }
  }, [_vm._v("9.1.1 Second Temple Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-9"
    }
  }, [_vm._v("9.1.2 Early Rabbinic Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-10"
    }
  }, [_vm._v("9.1.3 Medieval Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-11"
    }
  }, [_vm._v("9.1.4 Modern Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Introduction1#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.2 Christian Consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Introduction1#sec2-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.2.1 Early Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#sec2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.2.2 Medieval Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#sec2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.2.3 Reformation and the Rise of Biblical Criticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.3 Muslim Consequences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#sec2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.3.1 Qur’an")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#sec2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.3.2 Hadith Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#sec2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.3.3 Stories of the Prophets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.4 Jonah in the Modern World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#sec2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.4.1 The Enlightenment and Romanticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Introduction2#sec2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.4.2 Contemporary Approaches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Terror on the Stormy Sea (1:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec2-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prophet’s Resistance to YHWH’s Commission, Amplified (1:1–3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec2-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ship and the Sailors React to the Storm, Tarshish-Style (1:4–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Topside Dialogue about the Source of “This Evil” (1:8–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec2-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sailors Resist and Submit, Mostly (1:13–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retrospect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swallowed by a Big Fish (2:1–11; Eng. 1:17–2:10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec2-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prose Introduction: Jonah Swallowed (2:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec2-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stanza 1: The Waters of Death and Life (2:3–7b)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec2-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stanza 2: From the Depths to the Temple (2:7c–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Commentary#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retrospect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overturnings (3:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#sec2-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Overturning of Jonah (3:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#sec2-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Overturning Nineveh (3:5–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retrospect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Commentary1#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Aftermath (4:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#sec2-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonah’s Distress (4:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#sec2-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Plant, a Worm, and a Sirocco (4:6–8a)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#sec2-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonah’s Resistance, Again, and God’s Explanation of the Parable (4:8b–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retrospect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Commentary2#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c8f4adb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0